<template>
  <d-container fluid class="main-content-container px-4">
    <d-row>
      <d-col sm="8" md="6" lg="5" xl="4" style="max-width: 515px" class="mx-auto mt-4">
        <d-card class="card-small mb-4">
          <d-card-body class="p-0">
            <d-form class="py-4">
              <ValidationObserver ref="validationForm">
                <!-- Change Password -->
                <d-form-row class="mx-4">
                  <d-col class="mb-3">
                    <d-form-text tag="h5" class="mb-3">Alterar Senha</d-form-text>
                    <hr />
                  </d-col>
                </d-form-row>

                <d-form-row class="mx-4">
                  <!-- Old Password -->
                  <d-col md="12" class="form-group">
                    <label for="curPassword">Senha atual</label>
                    <ValidationProvider rules="required" v-slot="{errors, invalid}">
                      <d-input
                        :class="validatedForm | showValidateError(invalid)"
                        id="curPassword"
                        :disabled="loading"
                        v-model="AuthenticationPassword.OldPassword"
                        type="password"
                        placeholder="Senha atual"
                      />
                      <div class="invalid-feedback d-block" v-if="validatedForm">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </d-col>
                </d-form-row>

                <d-form-row class="mx-4">
                  <!-- New Password -->
                  <d-col md="12" class="form-group">
                    <label for="newPassword">Nova senha</label>
                    <ValidationProvider rules="required" name="passwordFieldOne" v-slot="{errors, invalid}">
                      <d-input
                        :class="validatedForm | showValidateError(invalid)"
                        id="newPassword"
                        :disabled="loading"
                        v-model="AuthenticationPassword.Password"
                        type="password"
                        placeholder="Nova senha"
                      />
                      <div class="invalid-feedback d-block" v-if="validatedForm">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </d-col>
                </d-form-row>

                <d-form-row class="mx-4">
                  <!-- Repeat New Password -->
                  <d-col md="12" class="form-group">
                    <label for="confirmNewPassword">Confirme a nova senha</label>
                    <ValidationProvider rules="required|confirmed:passwordFieldOne" v-slot="{errors, invalid}">
                      <d-input
                        :class="validatedForm | showValidateError(invalid)"
                        id="confirmNewPassword"
                        :disabled="loading"
                        v-on:keyup.enter.native="ChangePassword"
                        v-model="AuthenticationPassword.ConfirmPassword"
                        type="password"
                        placeholder="Confirme a nova senha"
                      />
                      <div class="invalid-feedback d-block" v-if="validatedForm">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </d-col>
                </d-form-row>
                <d-form-row class="mx-4">
                  <d-col md="12">
                    <div class="d-flex flex-column">
                      <span class="mb-2 mt-3 text-center">Requisitos complexidade da senha:</span>
                      <span class="req-item" :class="[pwdValidation.minChars ? 'pw-valid' : 'pw-invalid']">
                        <i v-if="pwdValidation.minChars" v-html="validIco"/>
                        <i v-else v-html="invalidIco"/>
                        A senha deve conter no mínimo 8 caracteres.
                      </span>
                      <span class="req-item" :class="[pwdValidation.minNumber ? 'pw-valid' : 'pw-invalid']">
                        <i v-if="pwdValidation.minNumber" v-html="validIco"/>
                        <i v-else v-html="invalidIco"/>
                        A senha deve conter ao menos um número.
                      </span>
                      <span class="req-item" :class="[pwdValidation.minUpperCase ? 'pw-valid' : 'pw-invalid']">
                        <i v-if="pwdValidation.minUpperCase" v-html="validIco"/>
                        <i v-else v-html="invalidIco"/>
                        <span>A senha deve conter ao menos uma letra maiúscula.</span>
                      </span>
                      <span class="req-item" :class="[pwdValidation.minLowerCase ? 'pw-valid' : 'pw-invalid']">
                        <i v-if="pwdValidation.minLowerCase" v-html="validIco"/>
                        <i v-else v-html="invalidIco"/>
                        <span>A senha deve conter ao menos uma letra minúscula.</span>
                      </span>
                      <span class="req-item" :class="[pwdValidation.minSpecialChar ? 'pw-valid' : 'pw-invalid']">
                        <i v-if="pwdValidation.minSpecialChar" v-html="validIco"/>
                        <i v-else v-html="invalidIco"/>
                        <span>A senha deve conter ao menos um caracter especial.</span>
                        <i
                          v-if="!pwdValidation.minSpecialChar"
                          class="far fa-question-circle ml-1"
                          style="font-size: 14px; color: grey"
                          v-b-tooltip.hover.bottom
                          title="Exemplos: ! @ # $ % & ( ) - + . , | ">
                        </i>
                      </span>
                      <span class="req-item" :class="[pwdValidation.threeCharSequence ? 'pw-valid' : 'pw-invalid']">
                        <i v-if="pwdValidation.threeCharSequence" v-html="validIco"/>
                        <i v-else v-html="invalidIco"/>
                        <span>A senha não pode conter uma sequência de caracteres iguais.</span>
                        <i
                          v-if="!pwdValidation.threeCharSequence"
                          class="far fa-question-circle ml-1"
                          style="font-size: 14px; color: grey"
                          v-b-tooltip.hover.bottom
                          title="Exemplos: 111, 333, aaa, bbb, @@@">
                        </i>
                      </span>
                    </div>
                  </d-col>
                </d-form-row>
              </ValidationObserver>
            </d-form>
          </d-card-body>

          <!-- Save Changes -->
          <d-card-footer class="border-top">
            <d-button
              size="sm"
              v-on:click.stop="ChangePassword()"
              :disabled="loading"
              class="btn-accent ml-auto d-table mr-3"
            >
              <template v-if="!loading">Alterar</template>
              <template v-else>
                <loader :small="true" :isLoading="loading"></loader>
              </template>
            </d-button>
          </d-card-footer>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
export default {
  name: "change-password",
  components: {},
  data() {
    return {
      AuthenticationPassword: {
        OldPassword: '',
        Password: '',
        ConfirmPassword: ''
      },
      loading: false,
      pwdValidation: {
        minChars: false,
        minLowerCase: false,
        minNumber: false,
        minSpecialChar: false,
        minUpperCase: false,
        threeCharSequence: false
      },
      validIco: "<i class='fas fa-check mr-2' style='color: #00FF00; width: 10px'>",
      invalidIco: "<i class='fas fa-times mr-2' style='color: #FF0000; width: 10px'>",
      validatedForm: false
    };
  },
  methods: {
    ChangePassword() {
      this.validatedForm = true;
      this.$refs.validationForm.validate().then(valid => {
        if (valid) {
          const pwdIsValid = this.ValidatePasswordStrength(this.AuthenticationPassword.Password);
          if (pwdIsValid) {
            this.CallChangePasswordAPI();
          } else {
            this.$makeToast(
              "A senha informada não atende aos requisitos de complexidade listados.",
              "danger",
              "Senha inválida"
            );
          }
        }
      });
    },
    CallChangePasswordAPI() {
      this.loading = true;
      this.AuthenticationPassword.Token = this.$getTokenAuth();
      this.AuthenticationPassword.Fingerprint = this.$getFingerprint();
      this.$store
        .dispatch("ChangePassword", this.AuthenticationPassword)
        .then(() => {
          this.$makeToast(
            `Senha alterada com sucesso!`,
            "success",
            "Alteração de senha"
          );
          this.ResetInitialState();
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível alterar sua senha.",
            'danger',
            "Alteração de senha",
            error
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ResetInitialState() {
      Object.assign(this.$data, this.$options.data());
    },
    ValidatePasswordStrength(pwd) {
      const regexDigits = /\d+/gm;
      const regexLower = /[a-z]+/gm;
      const regexUpper = /[A-Z]+/gm;
      const regexSpecial = /\W+/gm;
      const regexSequence = /^.*(.)\1\1.*$/gm;

      const leng = pwd != null ? pwd.length : 0;
      this.pwdValidation.minChars = leng >= 8 ? true : false;
      this.pwdValidation.minNumber = regexDigits.test(pwd);
      this.pwdValidation.minUpperCase = regexUpper.test(pwd);
      this.pwdValidation.minLowerCase = regexLower.test(pwd);
      this.pwdValidation.minSpecialChar = regexSpecial.test(pwd);
      this.pwdValidation.threeCharSequence = !regexSequence.test(pwd);

      let allValid = true;
      for (let rule in this.pwdValidation) {
        if (this.pwdValidation[rule] == false) {
          allValid = false;
          break;
        }
      }
      return allValid;
    }
  },
  watch: {
    "AuthenticationPassword.Password": function(nv) {
      this.ValidatePasswordStrength(nv);
    }
  }
};
</script>

<style scoped>
.req-item {
  font-size: 0.80rem;
}
.pw-valid {
  text-decoration: line-through;
  opacity: 0.5;
}
.pw-invalid {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/changePassword.vue